import { application } from "./application"

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import LaunchController from "./launch_controller"
application.register("launch", LaunchController)

import IdleController from "./idle_controller"
application.register("idle", IdleController)

import VideoController from "./video_controller"
application.register("video", VideoController)
